import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

import tours from './modules/tours'
import contact from './modules/contact'
import utils from './modules/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    tours,
    contact,
    utils
  }
  // plugins: [createPersistedState({
  //   paths: [
  //     'tours.ready',
  //     'tours.error',
  //     'tours.settings'
  //     'tours.photos',
  //     'tours.video',
  //     'tours.address',
  //     'tours.fullAddress',
  //     'tours.brokerage',
  //     'tours.details',
  //     'tours.floorplan'
  //   ]
  // })]
})
